// @flow

import React from 'react';

const Sent = ({ translate } : { translate: any }) => (
  <div className="reminder--body reminder--sended">
    <div className="sended-ico" />
    <h3>{translate('reminder.has_been_sent')}</h3>
    <div className='subtitle-sended'>
      {translate('reminder.support')}
      <a href={`mailto:${translate('common.email')}`}>{translate('common.header.email')}
      </a>
    </div>
    <div className='close-btn-box'>
      <button data-dismiss="modal" className="btn btn-success">
        {translate('reminder.close')}
      </button>
      </div>
  </div>
);

export default Sent;



// WEBPACK FOOTER //
// ./src/components/main/InsuranceInquiry/reminder/sent.js